module.exports = __webpack_public_path__ + "static/media/reviewIcon.6f5512eb.svg";